import { useContext, useEffect, useState } from "react";
import { NormalTableRow, SettingTable, SmallContentTableRow, SmallTextTableRow, settingUseStyles } from "../Settings";
import TextCell from "../components/TextCell";
import { Link, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Theme, styled, useMediaQuery } from "@mui/material";
import { getManagementInfo } from "../../../helpers/operationHelper";
import { showMessage } from "../../../store/reducer";
import { AppContext } from "../../../store/context";
import { IManagementInfo } from "../../../types/FaceVerification";
import { useSnackbar } from "notistack";
import { NavigationContext } from "../../../components/Navigation/store/context";
import { setDeveloperOptions } from "../../../components/Navigation/store/reducer";
import { APIsContext } from "../../../store/APIs/context";

const NameTableCell = styled(TableCell)(({theme}) => ({
    paddingLeft: "3rem",
    [theme.breakpoints.down("sm")]: {
        paddingLeft: "1rem"
    }
}));


const About: React.FC = () => {

    const classes = settingUseStyles();
    const appDispatch = useContext(AppContext).dispatch
    const apisState = useContext(APIsContext).state
    const {state, dispatch} = useContext(NavigationContext)
    const { enqueueSnackbar } = useSnackbar();
    const [managementState, setManagementState] = useState<IManagementInfo | null>(null);
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
    const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'));
    const [secretClicks, setSecretClicks] = useState(0)

    useEffect(() => {
        const fetchData = async () => {
            try {
                const managementInfo = await getManagementInfo(apisState.ManagementApi);
                if (!managementInfo) {
                    appDispatch(showMessage({ message: "Could not get management info", type: "error" }))
                    return;
                }
                setManagementState(managementInfo)
            } catch (error: any) {
                appDispatch(showMessage({ message: error.message, type: "error" }))
            }
        }
        fetchData()
    }, [appDispatch, apisState.ManagementApi])

    useEffect(() => {
        if (secretClicks > 6 && !state.developerOptions) {
            dispatch(setDeveloperOptions(true))
            enqueueSnackbar("Developer options enabled", {variant: "info"})
        }
    }, [secretClicks, dispatch, enqueueSnackbar, state.developerOptions])

    const secretClick = () => {
        setSecretClicks(secretClicks + 1)
        setTimeout(() => {
            setSecretClicks(0)
        }, 5000)
    }

    const getDate = (date: any): string => {
        if (date && date as unknown as number > 0) {
            return new Date(managementState?.buildDate as unknown as number).toISOString().split('T')[0]
        } else {
            return "none"
        }
    }

    const getColSpan = (): number => {
        if (isMobile)
            return 2
        if (isSmall)
            return 2;
        return 1
    }

    const showTableRow = (name: string, value: string, click?: () => void) => {
        if (isMobile) {
            return (
                <TableRow onClick={click? click : undefined}>
                    <NameTableCell width={"50%"} colSpan={getColSpan()}>
                        {name}
                    </NameTableCell>
                    <TableCell colSpan={3}>
                        {value}
                    </TableCell>
                </TableRow>
            );
        } if (isSmall) {
            return (
                <TableRow onClick={click? click : undefined}>
                    <NameTableCell width={"50%"} colSpan={getColSpan()}>
                        {name}
                    </NameTableCell>
                    <TableCell colSpan={3}>
                        {value}
                    </TableCell>
                </TableRow>
            );
        } else {
            return (
                <TableRow onClick={click? click : undefined}>
                    <NameTableCell width={"25%"} colSpan={getColSpan()}>
                        {name}
                    </NameTableCell>
                    <TableCell colSpan={3}>
                        {value}
                    </TableCell>
                </TableRow>
            );
        }
    }

    const contactUsRow = () => {
        if (isMobile) {
            return (
                <>
                <SmallTextTableRow>
                    <TextCell colspan={5} title="Need help or want to report an issue?" subtitle="Contact us"/>
                </SmallTextTableRow>
                <SmallContentTableRow>
                    <TableCell align="center" colSpan={3}>
                        <Link style={{textDecoration: "none", color: "#477eb8", fontSize: "0.9rem", fontWeight: 500}} href="mailto:faceverification@neurotechnology.com">faceverification@neurotechnology.com</Link>
                    </TableCell>
                </SmallContentTableRow>
                </>
            )
        } else {
            return (
                <NormalTableRow>
                    <TextCell colspan={3} title="Need help or want to report an issue?" subtitle="Contact us"/>
                    <TableCell>
                        <Link style={{textDecoration: "none", color: "#477eb8", fontSize: "0.9rem", fontWeight: 500}} href="mailto:faceverification@neurotechnology.com">faceverification@neurotechnology.com</Link>
                    </TableCell>
                </NormalTableRow>
            )
        }
    }

    return(
        <TableContainer component={Paper} className={classes.container}>
            <SettingTable>
                <TableHead>
                    <TableRow>
                        <TextCell colspan={5} head title="MegaMatcher ID Web demo" subtitle=""/>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {contactUsRow()}
                    {showTableRow("Version", (managementState?.version? managementState?.version : "none").toString(), secretClick)}
                    {showTableRow("Revision", (managementState?.revision? managementState?.revision : "none").toString().substring(0, 8))}
                    {showTableRow("Revision date", (managementState?.buildDate? getDate(managementState?.buildDate) : "none").toString())}
                </TableBody>
            </SettingTable>
        </TableContainer>
    );
}

export default About;